/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EventLogMetadataCampaignDto,
    EventLogMetadataCampaignDtoFromJSON,
    EventLogMetadataCampaignDtoFromJSONTyped,
    EventLogMetadataCampaignDtoToJSON,
} from './EventLogMetadataCampaignDto';
import {
    EventLogMetadataExternalDto,
    EventLogMetadataExternalDtoFromJSON,
    EventLogMetadataExternalDtoFromJSONTyped,
    EventLogMetadataExternalDtoToJSON,
} from './EventLogMetadataExternalDto';

/**
 * 
 * @export
 * @interface EventLogMetadataDto
 */
export interface EventLogMetadataDto {
    /**
     * 
     * @type {EventLogMetadataExternalDto}
     * @memberof EventLogMetadataDto
     */
    external?: EventLogMetadataExternalDto;
    /**
     * 
     * @type {EventLogMetadataCampaignDto}
     * @memberof EventLogMetadataDto
     */
    campaign?: EventLogMetadataCampaignDto;
    /**
     * 
     * @type {string}
     * @memberof EventLogMetadataDto
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof EventLogMetadataDto
     */
    userId?: string;
}

export function EventLogMetadataDtoFromJSON(json: any): EventLogMetadataDto {
    return EventLogMetadataDtoFromJSONTyped(json, false);
}

export function EventLogMetadataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventLogMetadataDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'external': !exists(json, 'external') ? undefined : EventLogMetadataExternalDtoFromJSON(json['external']),
        'campaign': !exists(json, 'campaign') ? undefined : EventLogMetadataCampaignDtoFromJSON(json['campaign']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
    };
}

export function EventLogMetadataDtoToJSON(value?: EventLogMetadataDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'external': EventLogMetadataExternalDtoToJSON(value.external),
        'campaign': EventLogMetadataCampaignDtoToJSON(value.campaign),
        'message': value.message,
        'userId': value.userId,
    };
}

